import { render, staticRenderFns } from "./ReadingCard.vue?vue&type=template&id=10c87510&scoped=true"
import script from "./ReadingCard.vue?vue&type=script&lang=ts"
export * from "./ReadingCard.vue?vue&type=script&lang=ts"
import style0 from "./ReadingCard.vue?vue&type=style&index=0&id=10c87510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c87510",
  null
  
)

export default component.exports